module.exports = __webpack_public_path__ + "img/PCAD_PrepaidCode_Website.0970dcd6.jpg";